
import UIView from './ui_view';
import BarrelView from './barrel_view';
import SlotView from './slot_view';
import FreegamesView from './freegames_view';
import RiskView from './risk_view';
import BonusView from "./bonus_view";
import SuperBonusView from "./superbonus_view";
import Roulette from './roulette';
import {JackpotScene} from './jackpot-scene';
import SETTINGS from "settings"

export default function (
    root,
    gameEntities,
    {
        uiConfig,
        spec,
    },
    parent,
)
{
    console.log( "Server spec:", spec );
    const $ticker = parent.s( "ticker" );
    
    const barrel = BarrelView(
        gameEntities.barrel,
        parent,
        $ticker,
        gameEntities.freeGamesBarrel
    );
    
    const slot = SlotView(
        gameEntities.slotScene.view,
        barrel.barrel,
        parent,
        $ticker,
    );
    
    // предположительно так - если в фригеймах барабан отличается от обычного
    // const freegameBarrel = BarrelView(new Barrel(barrelConfig, barrelConfig.symbolsCount));
    
    // ПРОБЛЕМА В ТОМ ЧТО В СЦЕНЕ МОЖЕТ НЕ БЫТЬ МЕТОДОВ КОТОРЫЕ ЕЙ БУДЕТ ДЕРГАТЬ VIEW
    // ЗАМЕНИТ НА ФЕЙК!!!
    const freegames = FreegamesView(
        gameEntities.slotScene.view,
        /*freegameBarrel*/
        parent,
        $ticker,
    );
    

    const risk = RiskView(
        gameEntities.doubleGameScene && gameEntities.doubleGameScene.view || undefined,
        parent,
        $ticker,
    );
    
    const bonus = BonusView(
        gameEntities.slotScene.view,
        gameEntities.bonusScene && gameEntities.bonusScene.view || undefined,
        parent,
        $ticker
    );
    
    const superbonus = SuperBonusView(
        gameEntities.slotScene.view,
        gameEntities.bonusScene && gameEntities.bonusScene.view || undefined,
        gameEntities.superBonusScene && gameEntities.superBonusScene.view || undefined,
        parent,
        $ticker
    );

    
    let scenes = [];
    for ( const i in gameEntities ) {
        const item = gameEntities[i];
        if (item && item.hasOwnProperty('view') && item.hasOwnProperty('z')) {
            scenes.push(item);
        }
    }
    
    // сортируем в порядке возрастания Z
    scenes.sort((a, b) => a.z - b.z);
    
    // добавляем в root
    for (const item of scenes) {
        if ( ! item.view ) continue
        root.addChild(item.view);
    }
    
    scenes = null;
    
    const mathConfig = {
        lines : spec.lines_array,
        multipliers : spec.bets_array,
    };
    
    const lobbyButtonContainer = new PIXI.Container;
    const ui = UIView({
        parent,
        uiConfig,
        lobbyButtonContainer,
        spec
    });
    // должен всегда добавляться последним
    root.addChild( ui.ui );
    
    
    const roulette = new Roulette( parent );
    roulette.scale.set( SETTINGS.screen.resolution.width / 1366, SETTINGS.screen.resolution.height / 768);
    const index = root.getChildIndex(gameEntities.slotScene.view);
    root.addChildAt( roulette, index + 1 );
    
    const jackpot = new JackpotScene( SETTINGS.screen, parent );
    root.addChildAt(jackpot, index+2);
    
    root.addChild( lobbyButtonContainer );
    
    const progressive_jackpot = new PIXI.Container
    root.addChild( progressive_jackpot )
    
    return {
        ui,
        barrel,
        slot,
        risk,
        help : gameEntities.helpScene.view,
        bonus,
        superbonus,
        roulette,
        jackpot,
        progressive_jackpot,
        freegames,
    };
}




// WEBPACK FOOTER //
// ./src/library/run.es6